import { defineStore } from "pinia";
import { markRaw } from "vue";

import DefaultModal from "@/components/ui/DefaultModal.vue";

import type {
  ModalOptions,
  ModalState,
} from "@/types/stores/modalStore.type.ts";

export const useModalStore = defineStore("modal", {
  state: (): ModalState => ({
    isOpen: false,
    component: null,
    props: {},
    maxWidth: 520,
    persistent: false,
    _resolver: null,
  }),
  actions: {
    openModal<TResult = unknown, TProps extends object = object>(
      options: ModalOptions<TProps>,
    ): Promise<TResult> {
      if (options.component) {
        this.component = markRaw(options.component);
        this.props = options.props || {};
      } else {
        this.component = markRaw(DefaultModal);
        this.props = options.props || {
          title: options.title,
          message: options.message,
          validateButton: options.validateButton,
          cancelButton: options.cancelButton,
          variant: options.variant,
        };
      }
      this.maxWidth = options.maxWidth || 520;
      this.persistent = options.persistent || false;

      this.isOpen = true;

      return new Promise<TResult>((resolve) => {
        this._resolver = (result: unknown): void => resolve(result as TResult);
      });
    },
    closeModal(result: unknown = null): void {
      this.isOpen = false;
      this.component = null;
      this.props = {};
      this.maxWidth = 520;
      this.persistent = false;
      if (this._resolver) {
        this._resolver(result);
        this._resolver = null;
      }
    },
  },
});
